import { BaseMenu as Menu } from './BaseMenu';
import { Item } from './components';
var menuItem = {
  Item
};
export var BaseMenu = Object.assign(Menu, menuItem);
//# sourceMappingURL=index.js.map